import React, { Suspense } from 'react'
import { Switch, Route, NotFound, Redirect, useRouteMatch } from '@fs/zion-router'
import ErrorBoundary from '@fs/zion-error-boundary'
import { useTranslation } from 'react-i18next'
import { useUser } from '@fs/zion-user'
import PageLoadingIndicator from '../../shared/components/PageLoadingIndicator'
import AAMMain from './components/AAMMain'
import AAMGuestMain from './components/AAMGuestMain'
import { AamProvider } from './state/AamStore'
import ConditionalHeader from '../../shared/components/ConditionalHeader/ConditionalHeader'
import DiscoveryExperienceHeader from '../../shared/components/DiscoveryExperienceHeader'
import useDSApplicationMode from '../../shared/hooks/useDSApplicationMode'
import Accessibility from '../../shared/components/Accessibility'
import useKiosk from '../../wss/global/hooks/useKiosk/useKiosk'

export default function AppAam({ nonstandardUser }) {
  const [t] = useTranslation()
  const appMode = useDSApplicationMode()
  const user = useUser()
  const unAuthUser = nonstandardUser && !nonstandardUser?.authenticated && !user.signedIn
  const RenderAAMMain = () => (unAuthUser ? <AAMGuestMain nonstandardUser={nonstandardUser} /> : <AAMMain />)
  const { path } = useRouteMatch()
  const yearPath = `${path}/year`
  const mainUrl = '/discovery/about/year'
  const title = t('dlp.discovery-landing-page.aam.title', 'All About Me')
  const Kiosker = () => {
    useKiosk({ listenForUndock: appMode === 'KIOSK' })
    return null
  }

  return (
    <ErrorBoundary>
      <ConditionalHeader activeExperienceId="discover" />
      <Kiosker />
      {(appMode === 'KIOSK' || appMode === 'STATION') && <Accessibility pullDown />}
      {appMode === 'WEB' && <DiscoveryExperienceHeader mainUrl={mainUrl} title={title} />}
      <AamProvider>
        <Suspense fallback={<PageLoadingIndicator />}>
          <Switch>
            <Route path={yearPath} render={RenderAAMMain} />
            <Route path={path} render={() => <Redirect to={yearPath} />} />
            <Route render={NotFound} />
          </Switch>
        </Suspense>
      </AamProvider>
    </ErrorBoundary>
  )
}
